import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-109c1b76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h" }
const _hoisted_2 = { class: "h-body h-ecologyt" }
const _hoisted_3 = { class: "w1200 h-company" }
const _hoisted_4 = { class: "h-company__icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "h-company__content" }
const _hoisted_7 = { class: "h-company__name" }
const _hoisted_8 = { class: "h-company__description" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 查看职位 ")
const _hoisted_10 = { class: "h-company__body" }
const _hoisted_11 = ["src", "onMouseover"]
const _hoisted_12 = { class: "h-company-item__name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "h-position-item__cn" }
const _hoisted_17 = { class: "h-position-item__en" }
const _hoisted_18 = { class: "h-position__body" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-position-item__cn" }, "更多职位", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-position-item__en" }, "More", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_header = _resolveComponent("z-header")!
  const _component_z_banner = _resolveComponent("z-banner")!
  const _component_z_title = _resolveComponent("z-title")!
  const _component_arrow_right_bold = _resolveComponent("arrow-right-bold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_z_life = _resolveComponent("z-life")!
  const _component_z_story = _resolveComponent("z-story")!
  const _component_z_footer = _resolveComponent("z-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_z_header, { type: "transparent" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_z_banner, { recruitingType: 1 }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_z_title, {
            cn: "业务介绍",
            en: "BUSINESS INTRODUCTION",
            class: "z_title"
          }),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "h-company__header",
              onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoSlide = false)),
              onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoSlide = true))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.company.img
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.company.name), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.company.description), 1),
                _createElementVNode("div", {
                  class: "h-body__more",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearchChange(_ctx.company.search)))
                }, [
                  _hoisted_9,
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_right_bold)
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_swiper, {
                ref: "mySwiper",
                class: "h-company__swiper",
                "slides-per-view": 8,
                "slides-per-group": 8,
                pagination: { clickable: true },
                onSwiper: _ctx.getSwiper
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                      class: "h-company__item",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: _normalizeClass(["h-company-item__icon", [_ctx.activeSilde == index ? 'h-company-item__icon__hover' : '']]),
                          src: item.img,
                          onMouseover: ($event: any) => (_ctx.handleCompanyClick(index)),
                          onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.autoSlide = true))
                        }, null, 42, _hoisted_11),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(16 - _ctx.companyList.length, (i) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, { key: i }))
                  }), 128)),
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onSwiper"])
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeEnum, (_item, _index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _index,
          class: _normalizeClass(`h-body w1200 h-${_item.key}`)
        }, [
          _createVNode(_component_z_title, {
            cn: _item.value,
            en: _item.name,
            class: "z_title"
          }, null, 8, ["cn", "en"]),
          (_item.key == `position`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posTypeEnum, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "h-position__body",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "h-position__item",
                      onClick: ($event: any) => (_ctx.handlePositionTypeClick(item))
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.value), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.key), 1)
                    ], 8, _hoisted_15)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: "h-position__item",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePositionTypeClick && _ctx.handlePositionTypeClick(...args)))
                  }, _hoisted_21)
                ])
              ]))
            : _createCommentVNode("", true),
          (_item.key == `life`)
            ? (_openBlock(), _createBlock(_component_z_life, {
                key: 1,
                recruitingType: 1,
                style: {"margin-top":"70px","padding-bottom":"120px"}
              }))
            : _createCommentVNode("", true),
          (_item.key == `story`)
            ? (_openBlock(), _createBlock(_component_z_story, {
                key: 2,
                recruitingType: 1,
                style: {"margin-top":"70px","padding-bottom":"120px"}
              }))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      _createVNode(_component_z_footer)
    ])
  ], 64))
}